import { render, staticRenderFns } from "./AiBots.vue?vue&type=template&id=2decd668&lang=pug"
import script from "./AiBots.vue?vue&type=script&lang=js"
export * from "./AiBots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports